import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { type Patient } from '@avanta/shared/types/patients';
import { useTranslation } from 'react-i18next';
import type { Appointment } from 'types/appointments';
import { CancelAppointment } from './components/CancelAppointment';
import { DownloadAppointmentPDF } from './components/DownloadAppointmentPDF';
import { EditAppointment } from './components/EditAppointment';

interface CardActionsProps {
  appointment: Appointment;
  patient?: Patient;
}

export const CardActions = ({ appointment, patient }: CardActionsProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <div className="flex items-center justify-between gap-6">
      <DownloadAppointmentPDF
        appointment={appointment}
        buttonLabel={t('DownloadAppointmentPDF.cta', { ns: LOCIZE_NS.APPOINTMENTS })}
      />
      <div className="flex items-center justify-end gap-3 max-am-lg:flex-col max-am-lg:items-stretch">
        <CancelAppointment
          appointment={appointment}
          buttonLabel={t('CancelSessionDialog.cta', { ns: LOCIZE_NS.INSURANCE })}
        />
        <EditAppointment
          appointment={appointment}
          patient={patient}
          buttonLabel={t('EditSessionDialog.cta', { ns: LOCIZE_NS.INSURANCE })}
        />
      </div>
    </div>
  );
};
